import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaHome, FaListAlt, FaPlus, FaUser, FaInfoCircle,
  FaShieldAlt, FaQuestionCircle, FaRocket, FaFileAlt, FaLock,
} from "react-icons/fa";
import "../sell-fast-page/info-page.css";

const SECTIONS = [
  {
    heading: "Main",
    links: [
      { label: "Home",         to: "/",           icon: <FaHome size={14} /> },
      { label: "All Ads",      to: "/ads?page=1",  icon: <FaListAlt size={14} /> },
      { label: "Post Free Ad", to: "/create-ad",   icon: <FaPlus size={14} /> },
      { label: "About Us",     to: "/about-us",    icon: <FaInfoCircle size={14} /> },
    ],
  },
  {
    heading: "Seller Tools",
    links: [
      { label: "Sell Fast Tips", to: "/sell-fast",      icon: <FaRocket size={14} /> },
      { label: "My Ads",         to: "/ad-settings",    icon: <FaListAlt size={14} /> },
      { label: "Profile Settings", to: "/profile-settings", icon: <FaUser size={14} /> },
    ],
  },
  {
    heading: "Help & Support",
    links: [
      { label: "FAQ",           to: "/faq",           icon: <FaQuestionCircle size={14} /> },
      { label: "Safety Tips",   to: "/safety-tips",   icon: <FaShieldAlt size={14} /> },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Terms & Conditions", to: "/terms",          icon: <FaFileAlt size={14} /> },
      { label: "Privacy Policy",     to: "/privacy-policy", icon: <FaLock size={14} /> },
    ],
  },
  {
    heading: "Account",
    links: [
      { label: "Sign In",    to: "/login",        icon: <FaUser size={14} /> },
      { label: "Register",   to: "/registration", icon: <FaPlus size={14} /> },
    ],
  },
];

function SitemapPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">Navigation</p>
            <h1 className="info-page__title">Sitemap</h1>
            <p className="info-page__subtitle">
              A complete overview of all pages on AdsOne.lk.
            </p>
          </div>

          {/* Grid of sections */}
          <div style={{ padding: "2.5rem", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "2rem" }}>
            {SECTIONS.map((section, i) => (
              <div key={i}>
                <h6 style={{ fontSize: "0.75rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "#94a3b8", marginBottom: "0.875rem", paddingBottom: "0.5rem", borderBottom: "2px solid #ed1b24", display: "inline-block" }}>
                  {section.heading}
                </h6>
                <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                  {section.links.map((link, j) => (
                    <li key={j}>
                      <Link
                        to={link.to}
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", color: "#475569", textDecoration: "none", fontSize: "0.9rem", transition: "color 0.15s" }}
                        onMouseEnter={e => (e.currentTarget.style.color = "#ed1b24")}
                        onMouseLeave={e => (e.currentTarget.style.color = "#475569")}
                      >
                        <span style={{ color: "#cbd5e1" }}>{link.icon}</span>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}

export default SitemapPage;
